import { IS_PROD } from './constants';
/**
 * Require used to avoid webpack treeshaking of import returning nothing.
 */

require('abort-controller/polyfill');

require('whatwg-fetch');

require('focus-visible');

require('intersection-observer');

if (!IS_PROD) console.log('Loading polyfills.');